module.exports = __webpack_public_path__ + "assets/img/cardItem04.97291027.png";